let messages = null;

const getTranslations = () => messages;
const setTranslations = (translations) => (messages = translations);

export default {
  get: getTranslations,
  set: setTranslations,
};
